import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import React, { Component } from 'react';
import App from "../../App";
import {withRouter} from "react-router-dom";
import "../../assets/scss/order-list.scss";
import AgentCommission from "./AgentCommission"
import SubAgentCommission from "./SubAgentCommission"
import { getFormattedDate } from "../../helper/utils";
import { getData } from "../../services/baseServices";

export const KEYS = {
    AGENT: 0,
    SUBAGENT: 1
}

class Details extends Component {
    constructor() {
        super();
        var seletedTab = localStorage.getItem("commission_tab") ? parseInt(localStorage.getItem("commission_tab")) : KEYS.AGENT;
        this.state = {
            selectedTab: seletedTab,
            details: {},
        };
    }


    getDetailsTransaction () {
        getData(`bank_transactions/${this.props.match.params.id}`)
        .then((res) => {
            this.setState({ details: res});
        })
        .catch((errMsg) => {
            console.log("Error Message: ", errMsg);
        });
    }

    componentDidMount() {
        this.getDetailsTransaction()
    }

    onTabChange = (key) => {
        localStorage.setItem("commission_tab", key)
        this.setState({selectedTab: key})
    }

    render() {
        const {details} = this.state;
        return (
            <App>
                <div className="page-header">
                    <h2 className="page-title">Commission</h2>
                </div>
                <div className="card-block">
                    <div className="block-body">
                        <table className='mb-3'>
                            <tbody>
                                <tr>
                                    <td>
                                        <span className="d-block"><strong>Distributor</strong> : {details.to_distributor}</span>
                                        <span className="d-block"><strong>Commission For</strong> : {details.transaction_type}</span>
                                        <span className="d-block"><strong>Transaction Id</strong> : {details.id}</span>
                                        <span className="d-block"><strong>Transaction Date</strong> : {getFormattedDate(details.collection_date,"DD-MM-YYYY")}</span>
                                        <span className="d-block"><strong>Total Amount</strong> : {details.amount}</span>
                                        <span className="d-block"><strong>From Bank Name</strong> : {details.from_bank}</span>
                                        <span className="d-block"><strong>To Bank Name</strong> : {details.to_bank}</span>
                                        <span className="d-block"><strong>Status</strong> : {details.is_approved? "Received": "Not received yet"}</span>
                                        <span className="d-block"><strong>Chalan Copy</strong> : 
                                            <img src={details.slip} alt="Chalan"></img>
                                        </span>
                                            
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {
                            details.transaction_type === 'agent_commission' ?
                                <AgentCommission/>
                            :
                                <SubAgentCommission/>
                        }
                    </div>
                </div>
            </App>
        );
    }
}

export default withRouter(Details);